import { getConfig, isConfigSet } from './AppConfig';

export const getOauthClientId = (forceOauthPrefix: boolean): string => {
    // Check for an override, for apps that don't conform to an [appname].[environment].[tld] convention
    const customClientId = getConfig()?.customClientId;
    if (customClientId) {
        return customClientId;
    }

    const { hostname } = window.location;
    const end = hostname.indexOf('.');
    let name = hostname.substring(0, end);

    // Special-case for anyone using http://localhost
    if (end === -1) {
        name = hostname;
    }
    let env = 'production'; // just to ensure it works in prod
    if (isConfigSet()) {
        const config = getConfig();
        env = config.environment;
    }

    if (forceOauthPrefix && !name.includes('central')) {
        // IDP requires central clientID to start with `central-` to be able to edit users
        // This is only a concern for the central portal slots
        return `central-${name}-${env}`;
    }

    const gcpEnvMap: Record<string, string> = {
        development: '.dev',
        integration: '.int',
        stage: '.stg',
    };
    const gcpDomainTemplate = (appList: string[]) =>
        `^(${appList.join('|')})[0-9]*${gcpEnvMap[env]}\\.seequent\\.com`;

    // Add the app name here when we have a GCP deployment for an app that only uses IMS
    const gcpIMSApps = [
        'evo',
        'blocksync',
        'geotech-reshape',
        'developer',
        'simval',
        'cpt2bh',
        'driver',
        'driverqa',
        'obsidian',
        'evonext',
    ];
    const gcpIMSHostPattern = new RegExp(gcpDomainTemplate(gcpIMSApps), 'i');
    // Remap client ID for apps that use GCP domains, as they require a different prefix to work with shared IMS configuration.
    // Also includes the strictly Evo Next applications' that are being developed/deployed on custom domains for now.
    if (gcpIMSHostPattern.test(hostname) || name === 'obsidian') {
        name = 'evo';
    }

    // Add the app name here when we have a GCP deployment for an app that uses SQID
    // (Also applies to apps supporting SQID and IMS)
    const gcpSQIDApps = ['central'];
    const gcpSQIDHostPattern = new RegExp(gcpDomainTemplate(gcpSQIDApps), 'i');
    if (gcpSQIDHostPattern.test(hostname)) {
        return `${name}-${env}-gcp`;
    }

    return `${name}-${env}`;
};
